export default function WorkOrderModel() {
  return {
    id: null,
    propertyId: null,
    propertyName: null,
    propertyNumber: null,
    reference: null,
    createdOn: null,
    closedOn: null,
    type: null,
    category: null,
    subCategory: null,
    state: null,
    status: null,
    description: null,
    diagnosis: null,
    reporterName: null,
    reporterType: null,
    reporterTelephone: null,
    reporterEmail: null,
    customerName: null,
    customerEmail: null,
    customerTelephone: null,
    workItems: [],
    cmvDueDate: null,
    cmvContactDate: null,
    projectId: null,
    projectName: null,
    // Required for updating
  };
}
